/* eslint-disable no-plusplus */
/* eslint-disable no-use-before-define */
/* eslint-disable consistent-return */
const words = ['Is it the creative?', 'Is it the audience?', 'Is it the outcomes?'];
let i = 0;

function deletingEffect() {
    const word = words[i].split('');
    const loopDeleting = function () {
        if (word.length > 0) {
            word.pop();
            document.getElementById('typewriter').innerHTML = word.join('');
        } else {
            if (words.length > (i + 1)) {
                i++;
            } else {
                i = 0;
            }
            typingEffect();
            return false;
        }
        setTimeout(loopDeleting, 50);
    };
    loopDeleting();
}

function typingEffect() {
    const word = words[i].split('');
    const loopTyping = function () {
        if (word.length > 0) {
            document.getElementById('typewriter').innerHTML += word.shift();
        } else {
            setTimeout(() => deletingEffect(), 2000);
            return false;
        }
        setTimeout(loopTyping, 50);
    };
    loopTyping();
}

if (document.getElementById('typewriter')) {
    typingEffect();
}

export { typingEffect as default };
